import * as e from "react";
import a from "../lib/IconBase.es.js";
import c from "../defs/ChatsCircle.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: c }));
o.displayName = "ChatsCircleIcon";
const m = o;
export {
  m as ChatsCircle,
  o as ChatsCircleIcon
};
